import React, { useEffect, useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { fetchEnvironmentVariables } from "../../api/adminService";
import NavComponent from "../../components/NavComponent";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { LegalDepositsSynchronize } from "../../components/admin/LegalDepositsSynchronize";
import { SendTestEmail } from "../../components/admin/SendTestEmail";
import { KeycloakBackfill } from "../../components/admin/KeycloakBackfill";
import { RegistrationEmail } from "../../components/admin/RegistrationEmail";
function AdminEnvironmentVariables() {
    var ky = useOkapiKy();
    var _a = useState([]), environmentVariables = _a[0], setEnvironmentVariables = _a[1];
    useEffect(function () {
        fetchEnvironmentVariables(ky).then(function (response) {
            setEnvironmentVariables(response.environmentVariables);
        });
    }, []);
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "25%", paneTitle: "Navigace", id: "menuPane" },
            React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                React.createElement(NavComponent, null))),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-users.admin.title" }) },
            React.createElement(FormattedMessage, { id: "ui-br-users.admin.description" }),
            React.createElement(FormattedMessage, { id: "ui-br-users.admin.title.environment.variables", tagName: "h1" }),
            React.createElement("ul", null, environmentVariables.map(function (environmentVariable) { return (React.createElement("li", { key: environmentVariable.name },
                React.createElement("strong", null,
                    environmentVariable.name,
                    ":"),
                environmentVariable.value)); })),
            React.createElement(LegalDepositsSynchronize, null),
            React.createElement(KeycloakBackfill, null),
            React.createElement(SendTestEmail, null),
            React.createElement(RegistrationEmail, null))));
}
export default AdminEnvironmentVariables;
